import template from './cameraPanel.html';

/* @ngInject */
function CameraPanelController(
  $scope,
  $uibModal,
  growl,
  CameraService,
  DashboardService,
  PTZControlsService,
  appConfig
) {
  const vm = this;

  /** * private variables ***/
  const DISABLED = 'disable';
  const DESTROY = 'destroy';
  const menuItems = {
    streamSettings: {
      text: 'Stream settings',
      do: openSettings,
    },
    ptzSettings: {
      text: 'PTZ settings',
      do: openPTZSettings,
    },
    zoneSettings: {
      text: 'Zones',
      do: openZoneSettings,
    },
    audioSettings: {
      text: 'Audio settings',
      do: openAudioSettings,
    }
  };


  /** * private functions ***/

  /** * public variables ***/
  vm.panel = null;
  vm.cameraPanelModel = {
    activeCameraId: '', // string
    activeCameraStream: '',
    cameraDetails: {},
    allCameras: {}
  };
  vm.hideLoadingSpinner = true;
  vm.editPanel = {
    needsToBeConfigured: false
  };

  /** * public functions ***/
  vm.$onInit = init;
  vm.$onDestroy = deletePanel;
  vm.setActiveCamera = setActiveCamera;
  vm.deletePanel = deletePanel;

  function init() {
    vm.currentDashboard = DashboardService.getCurrentDashboard();
    vm.panel = vm.currentDashboard.panels[vm.panelId];
    if (vm.panel.equipment && vm.panel.equipment.length > 0) {
      vm.hideLoadingSpinner = false;
      vm.editPanel.needsToBeConfigured = false;
      CameraService.setPanelGetEquipment(vm.panel.id, vm.panel.equipment)
        .then((equipment) => {
          if (_.size(equipment)) {
            vm.cameraPanelModel.allCameras = equipment;

            _.forEach(equipment, (eq) => {
              CameraService.retrieveStreamViews(eq)
                .then(() => {
                  if (!vm.cameraPanelModel.activeCameraId) {
                    setActiveCamera(eq);
                    vm.hideLoadingSpinner = true;
                  }
                });
            });
          } else {
            vm.editPanel.needsToBeConfigured = true;
          }
        });
      setPermissions();
    } else {
      vm.editPanel.needsToBeConfigured = true;
      vm.hideLoadingSpinner = true;
    }
  }

  function setActiveCamera(camera) {
    vm.cameraPanelModel.activeCameraId = camera.id;
    // use stream in panel config, else use first stream retrieved from rcu, else fallback to '1'
    vm.cameraPanelModel.activeCameraStream =
      vm.panel.config.defaultActiveStream || _.keys(camera.camsAndViews.views)[0] || '1';
    vm.cameraPanelModel.camera = camera;
    setPermissions();
  }


  const stopPlayer = () => $scope.$broadcast('stopPlayer');

  function openSettings(tab = 0) {
    stopPlayer();
    $uibModal.open({
      component: 'cameraSettingsModal',
      size: 'ex-lg',
      resolve: {
        cameraId() {
          return vm.cameraPanelModel.activeCameraId;
        },
        streamId() {
          return vm.cameraPanelModel.activeCameraStream;
        },
        loadingSpinners() {
          return false;
        },
        panel() {
          return vm.panel;
        },
        activeTab() {
          return tab;
        }
      },
      backdropClass: 'camera-settings-modal-window'
    })
      .closed
      .then(() => {
        $scope.$broadcast('streamSettingsUpdated');
      });
  }

  function openAudioSettings() {
    stopPlayer();
    $uibModal.open({
      component: 'camAudio',
      size: 'lg',
      resolve: {
        cameraId() {
          return vm.cameraPanelModel.activeCameraId;
        },
        loadingSpinners() {
          return false;
        },
        panel() {
          return vm.panel;
        }
      }
    });
  }

  async function openPTZSettings() {
    let canPtz;
    try {
      canPtz = await PTZControlsService.getPTZCapabilities(vm.cameraPanelModel.activeCameraId);
    } catch {}
    if (!canPtz) {
      growl.warning('PTZ is not enabled for this camera');
      return;
    }
    stopPlayer();
    $uibModal.open({
      component: 'ptzModalComponent',
      windowClass: 'lg-ptz-size',
      resolve: {
        cameraId() {
          return vm.cameraPanelModel.activeCameraId;
        },
        streamId() {
          return vm.cameraPanelModel.activeCameraStream;
        },
        panel() {
          return vm.panel;
        }
      }
    });
  }

  async function openZoneSettings() {
    stopPlayer();
    let component = 'zone';
    let motionConfig;
    try {
      const resp = await CameraService.getMotionDetectionConfig(
        vm.cameraPanelModel.activeCameraId,
        { encoding: 'binarystring' }
      );
      motionConfig = resp?.body;
      if (motionConfig?.module === 'cell') {
        component = 'cellGridMotion';
      }
    } catch {
      console.debug('GetMotionDetectionConfig endpoint not supported by this camera');
    }
    $uibModal.open({
      component,
      size: 'ex-lg',
      resolve: {
        name() {
          return vm.cameraPanelModel.camera.name;
        },
        camId() {
          return vm.cameraPanelModel.activeCameraId;
        },
        streamId() {
          return vm.cameraPanelModel.activeCameraStream;
        },
        loadingSpinners() {
          return false;
        },
        panel() {
          return vm.panel;
        },
        motionConfig() {
          return motionConfig;
        }
      },
      backdropClass: 'camera-settings-modal-window'
    });
  }

  function deletePanel() {
    CameraService.deletePanel(vm.panelId);
  }

  function setPermissions() {
    if (vm.cameraPanelModel?.camera?.equipmentType === 'radar') {
      vm.menu = undefined;
      return;
    }
    const permissions = _.get(appConfig, ['user', 'permissions', 'dashboard', 'cameras']);
    vm.menu = [];
    _.each(menuItems, (menuItem, permissionKey) => {
      const permission = _.get(permissions, permissionKey);
      if (permission !== DESTROY) {
        menuItem.disable = permission === DISABLED;
        vm.menu.push(menuItem);
      }
    });

    vm.menu = vm.menu.length ? vm.menu : undefined;
  }
}

export default {
  name: 'cameraPanel',
  template,
  controller: CameraPanelController,
  bindings: {
    panelId: '<'
  }
};
